<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<app-header></app-header>
<div class="container isBackgoround" style="padding: 0px">
  <main>
    <div class="v-application v-application--is-ltr theme--light main">
      <!-- <img
        class="mb-10"
        width="170px"
        src="/assets/sgzp-app2/images/icon_mail.svg"
        alt=""
      /> -->
      <form
        style="
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <h1 class="mb-10 h3">認証メールの再送信</h1>
        <p
          style="
            font-family: Noto Sans JP;
            font-size: 16px;
            font-weight: 400;
            line-height: 29px;
            letter-spacing: 0em;
            text-align: center;
            margin-bottom: 24px;
          "
        >
          下記に登録したメールアドレスを入力してください。<br />
          再度、認証メールをお送りします。
        </p>
        <div
          class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
          style="display: flex; justify-content: center"
          >
          <div class="v-input__control common_input">
            <div style="display: flex; align-items: center">
              <label
                for="input-13"
                class="bold"
                style="height: 29px; margin-right: 12px"
                >メールアドレス</label
              >
              <app-required-label></app-required-label>
            </div>
            <div class="v-input__slot">
              <input
                (focus)="focus(inputState.email)"
                (blur)="blur(inputState.email)"
                id="input-13"
                name="input-13"
                type="email"
                [(ngModel)]="email"
              />
            </div>
            <div class="v-text-field__details">
              <!-- エラー時 class="v-messages ..." に error--text を追加 ↓ -->
              <div class="v-messages theme--light error--text">
                <div
                  *ngIf="errorMessages.forgetpassword.email"
                  class="v-messages__wrapper"
                >
                  {{ errorMessages.forgetpassword.email }}

                  <!-- 注釈及びエラーテキストが入ります。 -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TODO アプリレイアウト -->
        <div class="text-center mb-6" style="width: 550px; max-width: 90vw">
          <button
            type="button"
            class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary primary-button"
            style="width: 100%"
            medium=""
            (click)="submit()"
          >
            <span class="v-btn__content bold"> 送信 </span>
          </button>
        </div>
        <div style="justify-content: center; display: flex">
          <a (click)="back()" class="text-link v-text-caption">
            戻る
          </a>
        </div>
      </form>
    </div>
  </main>
</div>
